<template>
  <div>
    <div
      v-if="displayOverlay"
      class="search-field-results__overlay"
      @click="searchDone"
    ></div>

    <div v-if="isLoading === 1"  class="search-field-results">
      <section class="search-fields-results__sections">
        <div class="search-field-results__section">
          <af-h4>
            Yrken
          </af-h4>

          <af-spinner
            v-if="isLoading === 1"
            :margin="30"
            :size="45">
          </af-spinner>
        </div>
        <div class="search-field-results__section">
          <af-h4>
            Kompetenser
          </af-h4>

          <af-spinner
            v-if="isLoading === 1"
            :margin="30"
            :size="45">
          </af-spinner>
        </div>
      </section>
    </div>

    <div v-if="hasCompetences || hasProfessions">
      <div v-if="!noResults" class="search-field-results">
        <section class="search-fields-results__sections">
          <div v-if="hasProfessions" class="search-field-results__section">
            <af-h4>
              YRKEN
            </af-h4>

            <ul class="search-field-results__list">
              <li
                v-for="profession in professions"
                :key="profession.path"
                class="search-field-results__list-item">
                <div @click="toggleSlider(profession)" v-html="profession.searchName" v-if="!profession.parentName.length"></div>
                <div @click="toggleSlider(profession)" v-html="`${profession.searchName} (${profession.parentName})`" v-else></div>
                <div class="search-field-results__range" v-if="sliderState(profession.path)">
                  <af-range
                    @clickedSliderButton="addProfession($event, profession)"
                    :showButton="true"
                    :config="{step: 1, connect: true, range: {min: [0], max: [10]}}"
                    :values="[0, 10]">
                    Vilken erfarenhet krävs?
                  </af-range>
                </div>
              </li>
            </ul>
          </div>

          <div v-if="hasCompetences" class="search-field-results__section">
            <af-h4>
              KOMPETENSER
            </af-h4>

            <ul class="search-field-results__list">
              <li
                v-for="competence in competences"
                :key="competence.path"
                class="search-field-results__list-item">
                <div
                  v-html="competence.searchName"
                  class="search-field-results__competence__title"
                  @click="toggleDropdown(competence)"></div>

                <div class="search-field-results__dropdown" v-if="dropdownState(competence.path)">
                  
                  <af-h4 class="search-field-results__dropdown-title">Vilken erfarenhet efterfrågas?</af-h4>
                <search-dropdown
                  :options="years"
                  inlinePlaceholder="Välj kompetensnivå"
                  label="Vilken erfarenhet efterfrågas?"
                  name="competenceYears"
                  @changed="addCompetence($event, competence)">
                </search-dropdown>
                </div>
              </li>
            </ul>
          </div>
        </section>
      </div>
    </div>

    <div class="search-field-results__no-results" v-if="noResults">
      Tyvärr finns inte det du söker
    </div>
  </div>
</template>

<script>
import AfH4 from '@/components/AfH4'
import AfRange from '@/components/AfRange'
import AfSpinner from '@/components/AfSpinner'
import Button from '@/components/Button/Button'
import SearchDropdown from '@/views/Search/SearchDropdown'
import * as types from '@/store/actionTypes'

export default {
  name: 'SearchFieldResults',

  props: {
    competences: Array,
    professions: Array,
    isLoading: Number,
    query: String
  },

  components: {
    AfH4,
    'af-button': Button,
    AfRange,
    AfSpinner,
    SearchDropdown
  },

  data() {
    return {
      expanded: [],
      expandedDropdown: [],
      years: [
        {
          name: 'Minst någon erfarenhet',
          path: 0
        },
        {
          name: 'Minst 1 års erfarenhet',
          path: 1
        },
        {
          name: 'Minst 2 års erfarenhet',
          path: 2
        },
        {
          name: 'Minst 5 års erfarenhet',
          path: 5
        }
      ]
    }
  },

  computed: {
    hasCompetences() {
      return this.competences.length > 0
    },
    hasProfessions() {
      return this.professions.length > 0
    },
    noResults() {
      return (
        this.professions.length === 0 &&
        this.competences.length === 0 &&
        this.query.length > 0 &&
        this.isLoading !== 1
      )
    },
    displayOverlay() {
      return this.hasCompetences || this.hasProfessions || this.noResults
    }
  },

  methods: {
    sliderState(path) {
      if (this.expanded.includes(path)) {
        return true
      }

      return false
    },
    dropdownState(path) {
      if (this.expandedDropdown.includes(path)) {
        return true
      }

      return false
    },
    toggleSlider({ path }) {
      if (this.expanded.includes(path)) {
        return this.expanded.splice(this.expanded.indexOf(path), 1)
      }

      this.expanded.push(path)
    },
    toggleDropdown({ path }) {
      if (this.expandedDropdown.includes(path)) {
        return this.expandedDropdown.splice(
          this.expandedDropdown.indexOf(path),
          1
        )
      }

      this.expandedDropdown.push(path)
    },
    addProfession(professionPayload, { name, path }) {
      const gt = parseInt(professionPayload[0].years, 10)
      const lt = parseInt(professionPayload[1].years, 10)
      let years = [
        {
          modifier: 'gte',
          years: gt
        }
      ]

      if (lt !== 10) {
        years = years.concat([
          {
            modifier: 'lte',
            years: lt
          }
        ])
      }

      const payload = {
        years,
        path,
        name
      }

      this.$store.commit(types.ADD_TO_QUERY, {
        payload,
        type: 'experiences'
      })

      window.eventBus.$emit('openExpansionPanel', {
        ...payload,
        type: 'experiences'
      })

      this.searchDone()
    },

    addCompetence(minYears, { name, path }) {
      const years = [
        {
          modifier: 'gte',
          years: minYears.path
        }
      ]

      const payload = {
        years,
        path,
        name
      }

      this.$store.commit(types.ADD_TO_QUERY, {
        payload,
        type: 'skills'
      })

      window.eventBus.$emit('openExpansionPanel', {
        ...payload,
        type: 'skills'
      })

      this.searchDone()
    },

    searchDone() {
      this.$emit('searchDone')
    }
  }
}
</script>

<style lang="postcss" scoped>
@import '../../variables/custom-media.css';

.search-field-results {
  background-color: var(--color-white);
  border-radius: 4px;
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.08);
  left: 0;
  margin-top: var(--spacing-third);
  padding: 25px var(--spacing-medium);
  position: absolute;
  left: 0;
  top: 150px;
  z-index: 3;

  @media (--bp-desktop) {
    top: 100%;
    width: 860px;
  }
}

.search-field-results__overlay {
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
}

.search-fields-results__sections {
  display: flex;
  flex-wrap: wrap;
}

.search-field-results__section {
  &:not(:last-child) {
    margin-bottom: var(--spacing-medium);
  }

  @media (--bp-desktop) {
    flex: 1;
    max-width: 50%;

    &:not(:last-child) {
      margin-bottom: 0;
      margin-right: var(--spacing-medium);
    }
  }
}

.search-field-results__list {
  @media (--bp-desktop) {
    margin-top: var(--spacing);
  }
}

.search-field-results__list-item {
  color: #000;
  cursor: pointer;
  font-size: 18px;
  padding: var(--spacing-third) 0;

  &:hover  {
    background-color: var(--color-porcelain);
  }

  @media (--bp-desktop) {
    padding: var(--spacing-half) var(--spacing-third);
  }
}

.search-field-results__range {
  margin-top: var(--spacing-half);
}

.search-field-results__dropdown {
  background-color: var(--color-iron);
  border-radius: 4px;
  padding: var(--spacing-medium);
}

.search-field-results__dropdown-title {
  margin-bottom: var(--spacing-medium) !important;
  text-align: center;
}

.search-field-results__footer {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.search-field-results__competence__title {
  @media (--bp-desktop) {
    margin-bottom: 10px;
  }
}

.search-field-results__no-results {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.08);
  color: var(--color-silver-chalice);
  left: 0;
  margin-top: var(--spacing-third);
  padding: var(--spacing-third);
  position: absolute;
  top: 100%;
  z-index: 3;
  width: 575px;

  @media (--ie11) {
    width: 545px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Search/SearchFieldResults.vue